import React from "react";

export default function Tag ({ text, onClick, icon }) {
  const styles = {
    container: {
      display: "inline-flex",
      alignItems: "center",
      backgroundColor: "#1F2A3A",
      color: "#fff",
      borderRadius: "6px",
      padding: "6px 12px",
      fontSize: "14px",
      fontWeight: "500",
      cursor: onClick ? "pointer" : "default",
      gap: "6px",
      transition: "background-color 0.2s ease",
    },
    icon: {
      fontSize: "14px",
    },
  };

  return (
    <div
      style={styles.container}
      onClick={onClick}
      onMouseEnter={(e) => (e.currentTarget.style.backgroundColor = "#2B3A50")}
      onMouseLeave={(e) => (e.currentTarget.style.backgroundColor = "#1F2A3A")}
    >
        {text}
    </div>
  );
};
